import cloneDeep from 'lodash-es/cloneDeep';
import { mergeAndRemoveDuplicates } from '@ourbranch/policy-utils';

export const getMerged = (segments, segmentId) => {
  const index = segments.findIndex((item) => item.segmentId === segmentId);
  const initialValue = segments[0];
  return segments.slice(0, index + 1).reduce(mergeAndRemoveDuplicates, cloneDeep(initialValue));
};

export const getMergedAllSegments = (segments) => segments.reduce(mergeAndRemoveDuplicates, cloneDeep(segments[0]));
